// extracted by mini-css-extract-plugin
export default {"modalOverlay":"tF-z","modalContent":"uF-z","header":"vF-z","close":"wF-z"};